export const storage = {
    TOKEN: 'token',
    SYMBOL: 'symbol'
};
